// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__18CV_","topBottomGutter":"Layout_topBottomGutter__33_Tz"};